$ = jQuery;
export const menu = {
  init: function () {
    var toggle = document.querySelector(".c-hamburger");

    toggle.addEventListener("click", function (e) {
      e.preventDefault();
      if (this.classList.contains("is-active") === true) {
        this.classList.remove("is-active");
        $("body").removeClass("menu-opened");
      } else {
        this.classList.add("is-active");
        $("body").addClass("menu-opened");
      }
    });
  },
};
